import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const h = e((c, i) => /* @__PURE__ */ l.jsx(
  a,
  {
    ref: i,
    ...c,
    image: (s) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...s,
        children: [
          /* @__PURE__ */ l.jsx("g", { clipPath: "url(#clip0_2974_4136)", children: /* @__PURE__ */ l.jsxs("g", { clipPath: "url(#clip1_2974_4136)", children: [
            /* @__PURE__ */ l.jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M16.158 29.011a2.3 2.3 0 0 1-.727.264 1.66 1.66 0 0 1-1.507-.497c-.43-.438-.74-1.14-.938-2.14-.399-2.029-.077-4.468.461-6.378.27-.96.603-1.818.95-2.449.172-.313.36-.595.563-.807.182-.19.478-.433.866-.433 1.26 0 2.46.88 3.65 2.241 3.788-5.594 10.396-9.146 17.724-8.787.764.034 1.514.119 2.24.228l.48.072.035.484c.052.73.06 1.471.017 2.214-.356 7.323-4.755 13.512-10.97 16.61 1.162 1.264 1.85 2.49 1.768 3.707v.005c-.03.385-.287.667-.496.844-.229.194-.528.368-.858.524-.666.313-1.56.595-2.553.803-1.976.413-4.472.561-6.5-.014-1-.282-1.687-.657-2.096-1.135a1.73 1.73 0 0 1-.39-1.572c.11-.46.373-.84.576-1.085l.02-.024c-1.284-.258-2.261-1.355-2.315-2.675m1.482-2.565q-.21 1.148-.27 2.344v.03c-.043.883.66 1.66 1.588 1.71h.039a19.4 19.4 0 0 0 2.916-.08l1.782-.453c-1.315-.688-2.572-1.631-3.556-2.751-.79-.898-1.421-1.931-1.752-3.05zm9.671 2.63c4.613-1.928 8.306-5.61 10.164-10.223-.599-.02-1.216-.227-1.79-.514-.87-.436-1.754-1.113-2.535-1.881-.783-.77-1.486-1.653-1.984-2.52-.346-.602-.618-1.24-.721-1.848-4.964 1.561-9.059 5.094-11.284 9.69-.298 1.496.77 3.396 1.887 4.666 1.207 1.372 2.895 2.466 4.54 3.07zm-5.183 2.57-2.576.655a3 3 0 0 0-.168.183c-.15.182-.281.392-.328.59-.039.165-.026.323.13.505.186.216.607.504 1.506.757 1.769.502 4.05.386 5.922-.006.932-.195 1.73-.452 2.286-.713a2.8 2.8 0 0 0 .591-.353 1 1 0 0 0 .073-.07c.023-.757-.464-1.727-1.705-3.007l-.168.043a20.3 20.3 0 0 1-5.563 1.416m-4.046-10.42.516-1.579c-1.125-1.292-2.001-1.83-2.702-1.863a1 1 0 0 0-.06.057 2.7 2.7 0 0 0-.377.553c-.29.527-.592 1.293-.846 2.194-.51 1.812-.787 4.044-.44 5.816.18.9.425 1.331.615 1.524.156.159.293.178.44.153.183-.031.389-.142.573-.277a3 3 0 0 0 .183-.15l.461-1.414c.32-1.768.877-3.45 1.637-5.015m14.134-7.89c-.356-.62-.55-1.16-.595-1.575 1.76-.432 3.614-.62 5.521-.526h.003c.546.024 1.09.077 1.63.147q.033.786-.012 1.573v.006a18.1 18.1 0 0 1-.835 4.633c-.387.117-.964.03-1.7-.338-.728-.365-1.51-.956-2.23-1.662-.716-.705-1.347-1.502-1.782-2.259m-5.25 5.704a3.15 3.15 0 0 0-2.243.795 3.06 3.06 0 0 0-1.02 2.134 3.05 3.05 0 0 0 .814 2.218c.559.602 1.335.96 2.158.998 1.707.081 3.182-1.22 3.265-2.928.085-1.704-1.259-3.136-2.973-3.217zm-1.436 1.698c.375-.334.87-.511 1.38-.488 1.069.05 1.87.937 1.82 1.948-.05 1.022-.94 1.827-1.998 1.777a1.918 1.918 0 0 1-1.327-.612 1.84 1.84 0 0 1-.493-1.337 1.83 1.83 0 0 1 .619-1.288m-14.144 8.283L8.25 31.24l.7.989 3.135-2.22zm1.643 3.315L8 36.45l.767.938 5.028-4.113zm2.473 2.504-2.514 2.468.848.864 2.515-2.467z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ l.jsx(
              "mask",
              {
                id: "mask0_2974_4136",
                width: 48,
                height: 48,
                x: 0,
                y: 0,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" })
              }
            )
          ] }) }),
          /* @__PURE__ */ l.jsxs("defs", { children: [
            /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_2974_4136", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }),
            /* @__PURE__ */ l.jsx("clipPath", { id: "clip1_2974_4136", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) })
          ] })
        ]
      }
    )
  }
));
h.displayName = "AgencyRocketshipIcon";
export {
  h as AgencyRocketshipIcon,
  h as default
};
//# sourceMappingURL=index.js.map
